import { render } from "./ProductSelectionProducts.vue?vue&type=template&id=7ee9be83&scoped=true&ts=true"
import script from "./ProductSelectionProducts.vue?vue&type=script&lang=ts"
export * from "./ProductSelectionProducts.vue?vue&type=script&lang=ts"

import "./ProductSelectionProducts.vue?vue&type=style&index=0&id=7ee9be83&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/bouwstenen/Bouwsteen_BuildAndDeploy_Vue_Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ee9be83"]])

export default __exports__